module.exports = __webpack_public_path__ + "static/media/delete-timeblock.b64ab601.svg";